import { useQuery } from "@tanstack/react-query"

import { api } from "@/api/cliente"

/**
 * Lo que presta un proveedor y a qué precio (04/11), de `GET /proveedores/{id}/servicios`.
 *
 * ⚠ **El precio ya viene resuelto por el servidor** (`monto`): el suyo, o el de referencia
 * del servicio si no tiene. La ficha, la orden de pago y —más adelante— la cotización leen
 * esta misma respuesta con la MISMA clave, así que comparten caché.
 */

export type ServicioOfrecido = {
  gasto_id: number
  codigo: string
  nombre: string
  categoria_id: number | null
  categoria: string | null
  tipo_gasto: "FIJO" | "VARIABLE"
  /** `TIPO`: del catálogo de uno de sus tipos, marcado en su ficha. `PROPIO`: sólo suyo. */
  origen: "PROPIO" | "TIPO"
  tipo_proveedor: string | null
  monto: string | null
  divisa_id: number | null
  divisa: string | null
  /** Si el precio es suyo y no el de referencia del servicio. */
  precio_propio: boolean
  monto_referencia: string | null
  divisa_referencia: string | null
}

export type ServicioDisponible = {
  gasto_id: number
  nombre: string
  tipo_proveedor: string | null
  categoria: string | null
  monto_referencia: string | null
  divisa: string | null
}

export type ServiciosProveedor = {
  proveedor_id: number
  tipos: { id: number; nombre: string }[]
  ofrecidos: ServicioOfrecido[]
  disponibles: ServicioDisponible[]
}

export const claveServicios = (proveedorId: number | null) => ["proveedor-servicios", proveedorId]

export function useServiciosProveedor(proveedorId: number | null, habilitado = true) {
  return useQuery({
    queryKey: claveServicios(proveedorId),
    queryFn: () => api.get<ServiciosProveedor>(`/api/v1/proveedores/${proveedorId}/servicios`),
    enabled: proveedorId !== null && habilitado,
  })
}
